export const loadFont = () => {
  const fontUrl = "https://volt-images-alpha.s3.ap-south-1.amazonaws.com/simonsonBold.otf";
  const fontFace = new FontFace("MyCustomFont", `url(${fontUrl})`);

  const interSimonson = "https://volt-images-alpha.s3.ap-south-1.amazonaws.com/simonsonRegular.otf";
  const interSimonsonFontFace = new FontFace("InterSimonson", `url(${interSimonson})`);

  Promise.all([
    fontFace.load().then((loaded) => document.fonts.add(loaded)),
    interSimonsonFontFace.load().then((loaded) => document.fonts.add(loaded)),
  ]).catch((err) => {
    console.error("Failed to load custom fonts:", err);
  });
};